/** @format — Map tracking.map AG-UI props → mini-map + card labels */

import { mapTrackingStreamPropsToShipment } from "../../../pages/tracking/trackingMappers";
import { toLatLng } from "../../../pages/tracking/routeGeometry";
import { getShipmentStatusLabel } from "@/utils/shipmentStatus";
import { describeMissingPosition } from "@/utils/trackingStatus";

export function mapPropsToMiniMapModel(props = {}) {
  const shipment = mapTrackingStreamPropsToShipment(props);
  const tracking = props.tracking ?? {};
  const map = tracking.map ?? props.map ?? {};
  const current = map.currentPosition ?? tracking.position?.current ?? props.currentPosition;
  const origin = map.origin ?? props.origin;
  const destination = map.destination ?? props.destination;

  const locationName =
    origin?.name && typeof origin !== "string"
      ? origin.name
      : typeof origin === "string"
        ? origin
        : shipment.origin ?? "Origin";

  const latLonLabel =
    shipment.latLonLabel ??
    (current?.lat != null && current?.lng != null
      ? `${Math.abs(current.lat).toFixed(1)}°${current.lat >= 0 ? "N" : "S"}, ${Math.abs(current.lng).toFixed(1)}°${current.lng >= 0 ? "E" : "W"}`
      : null);

  // #502: no live fix -> explain why the route has no vessel marker, from the
  // backend's position.status (falls back to the shipment lifecycle status).
  const hasVesselFix = current?.lat != null && current?.lng != null;
  const missingPositionReason = hasVesselFix
    ? null
    : describeMissingPosition(
        tracking.position?.status ?? props.positionStatus,
        props.status ?? tracking.status,
      );

  return {
    ...shipment,
    originPosition: toLatLng(origin),
    destinationPosition: toLatLng(destination),
    locationName,
    latLonLabel,
    missingPositionReason,
    // #505: always derive the label from the status VALUE via the single
    // design-system map — never render a backend-provided label string (e.g.
    // status_label's "In transit — ocean"), so the map card and the shipment
    // card can't show two different words for the same state ("At sea").
    statusLabel: getShipmentStatusLabel(props.status ?? tracking.status),
  };
}
